import { render, staticRenderFns } from "./BaseCheckboxes.vue?vue&type=template&id=4cda7a5a"
import script from "./BaseCheckboxes.vue?vue&type=script&lang=js"
export * from "./BaseCheckboxes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports